module.exports = __webpack_public_path__ + "img/align-justify.45a26f09.svg";